import { CustomProductAttributeConfig } from 'ZalamoLibrary/src/lib/ui/products/types';

export function normalizeProductConfig(
  config,
  configInShop: Array<CustomProductAttributeConfig>
) {
  const temp = { ...config };
  Object.entries(temp)
    .filter(
      ([index, value]) =>
        configInShop.find((value1) => value1.customId === index).type ===
          'boolean' && value === ''
    )
    .forEach(([index]) => (temp[index] = false));
  Object.entries(temp)
    .filter(
      ([index, value]) =>
        ['list', 'size', 'decoration'].includes(
          configInShop.find((value1) => value1.customId === index).type
        ) && value === false
    )
    .forEach(([index]) => (temp[index] = ''));
  return temp;
}
